// Imagens de exemplo (data URI PNG) só para as páginas de dev-preview dos PDFs, para conferir
// o layout do logo/assinaturas sem depender do backend. NÃO usar em produção.

// PNG 1x1 opaco (cinza claro) — escalado pelo <Image>, vira um retângulo de cor sólida.
export const LOGO_EXEMPLO =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwAEhQGA5KJn5QAAAABJRU5ErkJggg==';

// PNG 1x1 opaco (azul) para as assinaturas.
export const ASSINATURA_EXEMPLO =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADElEQVR42mNgYPhfDwAChwGA1jREuQAAAABJRU5ErkJggg==';
